import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _defineProperty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Form from 'react-bootstrap/Form';
import styles from '../styles/file-uploader.less';
//import Select from 'react-select';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TextField from '@mui/material/TextField';
import { ExpandMore as ExpandMoreIcon } from "../../icons.js";
import { SimpleGraphShaper } from './ShaperSimple';
import { Encoder } from './Encoder';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('Visualizer');
export var SHAPER_SIMPLE = 'simple';
export var SHAPER_UNKNOWN = 'unknown';
export var SHAPER_TO_NAME = _defineProperty(_defineProperty({}, SHAPER_SIMPLE, 'Node, edge tables'), SHAPER_UNKNOWN, 'Undefined');
function UnknownShaper(_ref) {
  _objectDestructuringEmpty(_ref);
  return 'unknown shaper';
}
export function Visualizer(props) {
  var visible = props.visible,
    user = props.user,
    files = props.files,
    visualizationBindings = props.visualizationBindings,
    setVisualizationBindings = props.setVisualizationBindings;
  if (!visible) {
    return null;
  }
  log.debug({
    user: user,
    files: files
  }, 'Visualizer');
  var setVizPropByEventTargetValue = function setVizPropByEventTargetValue(propName) {
    return function (event) {
      log.debug({
        propName: propName,
        event: event
      }, 'Set viz prop (event trigger)');
      if (!event || !event.target) {
        log.warn({
          event: event
        }, 'setVizPropByEventTargetValue event without target');
        return;
      }
      var val = event.target.value; //may be nulled later?
      setVisualizationBindings(function (vizBindings) {
        return _objectSpread(_objectSpread({}, vizBindings), {}, _defineProperty({}, propName, val));
      });
    };
  };
  var accordionOpts = function accordionOpts() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread({
      TransitionProps: {
        unmountOnExit: true
      },
      className: "".concat(styles['shaper-accordion'])
    }, overrides);
  };
  var accordionSummaryOpts = function accordionSummaryOpts() {
    return {
      expandIcon: /*#__PURE__*/_jsx(ExpandMoreIcon, {}),
      className: "".concat(styles['shaper-accordion-summary'])
    };
  };
  var accordionDetailsOpts = function accordionDetailsOpts() {
    return {
      className: "".concat(styles['shaper-accordion-details'])
    };
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles['cleaner'],
    children: [/*#__PURE__*/_jsx("h5", {
      className: styles['dropper-instr-header'],
      children: "Shape files into a graph"
    }), (visualizationBindings.layout === SHAPER_SIMPLE ? SimpleGraphShaper : UnknownShaper)(props), null /* <Accordion {...(accordionOpts())} >
                                                                                                          <AccordionSummary {...(accordionSummaryOpts())}
                                                                                                            aria-controls="Encodings-settings-control"
                                                                                                            id="Encodings-settings-control"
                                                                                                          >
                                                                                                           <h4>Encode</h4>
                                                                                                          </AccordionSummary>
                                                                                                          <AccordionDetails {...(accordionDetailsOpts())}>
                                                                                                           <Encoder {...props} />
                                                                                                          </AccordionDetails>
                                                                                                          </Accordion> */]
  });
}